import ProgressBar from '@/src/Common/components/ProgressBar';
import { Heading } from '@/src/tailwindui/heading';
import CreateEventStepOne from './CreateEventStepOne';
import useCreateEvent from './hooks/useCreateEvent';
import CreateEventStepTwo from './CreateEventStepTwo';
import CreateEventStepThree from './CreateEventStepThree';
import { cn } from '@/src/lib/utils';
import clickerboothLogo from '../../clickerbooth_logo.png';
import romrLogo from '../../romr_logo.png';

export default function CreateEvent() {
    const {
        steps,
        goToStep,
        platform,
        setPlatform,
        experience,
        setExperience,
        experienceTemplates,
        recordValues,
        saveEvent,
        processingFlowTemplates,
        templateValues,
        setTemplateValues,
        foregroundColor,
        backgroundColor,
        headerForegroundColor,
        headerBackgroundColor,
        customMessage,
        shareViaText,
        shareViaEmail,
        galleryLogo,
        setForegroundColor,
        setBackgroundColor,
        setHeaderForegroundColor,
        setHeaderBackgroundColor,
        setCustomMessage,
        setShareViaText,
        setShareViaEmail,
        setGalleryLogo,
        processingFlowTemplate,
        setProcessingFlowTemplate,
        eventName,
        setEventName,
        eventDate,
        setEventDate,
        eventLocation,
        setEventLocation,
    } = useCreateEvent();

    return (
        <div className="mx-auto max-w-4xl">
            <div
                className={cn(
                    'transition-all duration-300',
                    platform !== null && 'opacity-0 h-0 hidden',
                )}
            >
                <div className="flex justify-center items-center my-12">
                    <Heading className="text-4xl plex-sans">
                        Choose a platform
                    </Heading>
                </div>

                <div className="grid grid-cols-2 items-end justify-between gap-4">
                    <div
                        className="border-2 border-gray-200 rounded-lg p-4 flex justify-center items-center hover:bg-gray-100 transition-all duration-300 cursor-pointer"
                        onClick={() => setPlatform('romr')}
                    >
                        <img
                            src={romrLogo}
                            aria-label="romr"
                            className="h-[48px] scale-75 clickable cursor-pointer object-contain pe-logo"
                        />
                    </div>
                    <div
                        className="border-2 border-gray-200 rounded-lg p-4 flex justify-center items-center hover:bg-gray-100 transition-all duration-300 cursor-pointer"
                        onClick={() => setPlatform('clickerbooth')}
                    >
                        <img
                            src={clickerboothLogo}
                            aria-label="clickerbooth"
                            className="h-[48px] scale-75 clickable cursor-pointer object-contain pe-logo"
                        />
                    </div>
                </div>
            </div>
            <div
                className={cn(
                    'flex flex-wrap items-end justify-between gap-4 transition-all duration-300',
                    platform === null && 'hidden opacity-0',
                )}
            >
                <div>
                    <Heading className="text-4xl plex-sans">
                        Create an Event
                    </Heading>
                </div>
            </div>
            <div
                className={cn(
                    'transition-all duration-300 opacity-100',
                    platform === null && 'opacity-0 hidden',
                )}
            >
                <div className="my-7" />
                <ProgressBar steps={steps} setStep={goToStep} />

                <div className="my-10 mt-6" />
                {steps[0].status === 'current' && (
                    <CreateEventStepOne
                        onNext={() => goToStep('Step 2')}
                        recordValues={recordValues}
                        eventName={eventName}
                        setEventName={setEventName}
                        eventDate={eventDate}
                        setEventDate={setEventDate}
                        eventLocation={eventLocation}
                        setEventLocation={setEventLocation}
                    />
                )}
                {steps[1].status === 'current' && (
                    <CreateEventStepTwo
                        platform={platform}
                        experience={experience}
                        setExperience={setExperience}
                        experienceTemplates={experienceTemplates}
                        recordValues={recordValues}
                        onNext={() => goToStep('Step 3')}
                        processingFlowTemplate={processingFlowTemplate}
                        setProcessingFlowTemplate={setProcessingFlowTemplate}
                        processingFlowTemplates={processingFlowTemplates}
                        templateValues={templateValues}
                        setTemplateValues={setTemplateValues}
                    />
                )}
                {steps[2].status === 'current' && (
                    <CreateEventStepThree
                        onNext={() => {
                            saveEvent();
                        }}
                        foregroundColor={foregroundColor}
                        backgroundColor={backgroundColor}
                        headerForegroundColor={headerForegroundColor}
                        headerBackgroundColor={headerBackgroundColor}
                        customMessage={customMessage}
                        shareViaText={shareViaText}
                        shareViaEmail={shareViaEmail}
                        galleryLogo={galleryLogo}
                        setForegroundColor={setForegroundColor}
                        setBackgroundColor={setBackgroundColor}
                        setHeaderForegroundColor={setHeaderForegroundColor}
                        setHeaderBackgroundColor={setHeaderBackgroundColor}
                        setGalleryLogo={setGalleryLogo}
                        setCustomMessage={setCustomMessage}
                        setShareViaText={setShareViaText}
                        setShareViaEmail={setShareViaEmail}
                    />
                )}
            </div>
        </div>
    );
}
